module.exports = fox._r("images/promo/tutorial/16.png", __webpack_public_path__ + "_/common/images/promo/tutorial/16.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/promo/tutorial/16.png
// module id = 663
// module chunks = 2